import React, { FC, useEffect } from 'react';

import { LandscapeProjectsAddProjectsSupportersTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useParams } from 'react-router-dom';
import {
  deleteProjectSupporters,
  fetchProjectSupportersByIds,
  fetchProjectSupportersByOrganizationId,
} from '../../../store/tradeAPI/projectSupporter/reducers/project-supporters.slice';
import { ProjectOrganizationResponseDto } from '../../../store/tradeAPI/projectSupporter/dto/response/project-organization-response.dto';
import Spinner from '../../atoms/Spinner/Spinner';
import { ProjectOrganizationRelationType } from '../../../store/tradeAPI/projectSupporter/project-organization-relation-type';
import LandscapeProjectNotSavedInfoPage from '../LandscapeProjectNotSavedInfoPage';

interface LandscapeProjectsAddProjectsSupportersPageProps {}

const LandscapeProjectsAddProjectsSupportersPage: FC<
  LandscapeProjectsAddProjectsSupportersPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { projectId } = useParams();

  const { projectBuyers, status } = useSelector(
    (state: RootState) => state.projectSupporterSlice
  );

  useEffect(() => {
    if (projectId && projectId !== 'new-project') {
      dispatch(
        fetchProjectSupportersByIds({
          id: projectId,
          relationShipType: ProjectOrganizationRelationType.Supporters,
        })
      );
    }
  }, [dispatch, projectId]);

  const handleDelete = async (buyerId: string) => {
    await dispatch(fetchProjectSupportersByOrganizationId(buyerId))
      .unwrap()
      .then((supporters: ProjectOrganizationResponseDto[]) => {
        const supporterToDelete = supporters.find(
          (supporter) => supporter.projectId === projectId
        )!;

        dispatch(deleteProjectSupporters(supporterToDelete.id))
          .unwrap()
          .then(() => {
            dispatch(
              fetchProjectSupportersByIds({
                id: projectId!,
                relationShipType: ProjectOrganizationRelationType.Supporters,
              })
            ).unwrap();
          });
      });
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return projectId && projectId !== 'new-project' ? (
    <LandscapeProjectsAddProjectsSupportersTemplate
      data={projectBuyers ?? []}
      handleDelete={handleDelete}
    />
  ) : (
    <LandscapeProjectNotSavedInfoPage />
  );
};

export default LandscapeProjectsAddProjectsSupportersPage;
